import React, { useContext, useEffect, useMemo, useState } from 'react'
import { ReactComponent as Info } from './icons/info.svg'
import { ReactComponent as InfoBig } from './icons/info-big.svg'
import CloseButton from '../../../CloseButton'
import useDetectDevice from '../../../../hooks/useDetectDevice'
import BottomSheet from '../../../BottomSheet'
import { useDetectClickOutside } from 'react-detect-click-outside'
import { captureEvent } from '../../../../analytics'
import { analyticsEvents } from '../../../../analytics/events'
import { AppConfigContext } from '../../../../context/AppConfig'
import { getDisclaimer } from '../../../../helpers/disclaimer'
import { useStore } from '../../../../store'
import { eventBus } from '../../../../helpers/events'
import { isStagedWithCortPackage } from '../../../../helpers/packages'

function DisclaimerContent({ onClose, content }) {
  return (
    <>
      <div className="flex justify-between items-center">
        <div className="text-[20px] font-semibold text-[var(--brand-color)]">Disclaimer</div>
        <div className="hidden lg:block">
          <CloseButton
            onClick={() => {
              onClose()
            }}
          />
        </div>
      </div>
      {content}
    </>
  )
}

function Modal({ onClose, children, classList = '', contentClassList = '' }) {
  const [mounted, setMounted] = useState(false)

  useEffect(() => {
    setMounted(true)
  }, [])

  const ref = useDetectClickOutside({
    onTriggered: () => {
      if (mounted) {
        onClose && onClose()
      }
    },
  })

  return (
    <div
      className={`fixed top-0 left-0 w-[calc(100vw-var(--sidebar-shown-width))] h-[calc(100%-30px)] flex items-center justify-center ${classList}`}
      onClick={onClose}
    >
      <div
        ref={ref}
        className={`bg-white border-[1px] border-solid border-[#C7CCD9] bottom-[150px] lg:bottom-[100px] w-[calc(100vw-48px)] lg:w-[492px] rounded-[6px] rounded-br-none right-0 p-[20px] lg:p-[24px] z-[10] ${contentClassList}`}
        onClick={(e) => e.stopPropagation()}
      >
        {children}
      </div>
    </div>
  )
}

function Disclaimer({ className = '', selectedPackage, btnClassName = '', ...props }) {
  const [shown, setShown] = useState(false)


  const tnc = useMemo(() => {
    if (selectedPackage) {
      return selectedPackage.terms_and_conditions?.tnc
    }
  }, [selectedPackage])

  

  const { variant } = useContext(AppConfigContext)
const { data } = useStore()
  const items = useMemo(() => {
    return getDisclaimer(variant, data?.property) || []
  }, [variant, data])


  useEffect(()=>{
    eventBus.subscribe('packageSelected', (e) => {
      if(data?.property?.property_name.toLowerCase().includes('demo') || isStagedWithCortPackage(e.package)) {
         setShown(true)
      } else {
         setShown(false)
      }
    })
    return () => {
      eventBus.unsubscribe('packageSelected')
    }
  }, [])

  const list = (
    <ul className="list-disc pl-[20px] mt-[10px]">
      {items.map((i, index) => (
        <li key={index}>{i}</li>
      ))}

      {tnc && (
        <>
          {tnc.map((i) => (
            <li>{i}</li>
          ))}
        </>
      )}
    </ul>
  )

  const { isMobile, isDesktop } = useDetectDevice()

  useEffect(() => {
    if (shown) {
      captureEvent(analyticsEvents.DISCLAIMER_VIEWED)
    }
  }, [shown])

  return (
    <>
      <button
        onClick={() => {
          captureEvent(analyticsEvents.DISCLAIMER_TAPPED)
          setShown(!shown)
        }}
        type="button"
        className={`text-[#3D4256] text-medium underline text-[12px] relative portrait:z-[40] lg:landscape:z-[40] ${btnClassName}`}
      >
        Disclaimer
      </button>

      <>
        {isDesktop && (
          <>
            {shown && (
              <Modal
                onClose={() => {
                  captureEvent(analyticsEvents.DISCLAIMER_CLOSED)
                  setShown(false)
                }}
                classList={`!items-end text-black`}
                contentClassList="!w-[calc(100%-48px)] lg:!w-[812px] mb-[78px] !rounded-[6px]"
              >
                <DisclaimerContent
                  content={list}
                  onClose={() => {
                    captureEvent(analyticsEvents.DISCLAIMER_CLOSED)
                    setShown(false)
                  }}
                />
              </Modal>
            )}
          </>
        )}
        {isMobile && (
          <BottomSheet
            transparentOverlay
            closeOnClickOutside
            open={shown}
            onToggle={() => {
              if (shown) {
                captureEvent(analyticsEvents.DISCLAIMER_CLOSED)
              }
              setShown(false)
            }}
          >
            <div className="mb-[40px] portrait:mb-0 lg:mb-0">
              <DisclaimerContent content={list} />
            </div>
          </BottomSheet>
        )}
      </>
    </>
  )
}

export default Disclaimer
